
import { getSliceComponentProps } from '@prismicio/vue/components'

export default {
  name: 'HeroSlice',
  // The array passed to `getSliceComponentProps` is purely optional and acts as a visual hint for you
  props: getSliceComponentProps(['slice', 'index', 'slices', 'context']),
  data() {
    return {
      isVideoModalOpen: false,
    }
  },
  computed: {
    modifiedVideoEmbedded() {
      if (this.$props.slice.primary.hero_video_embedded) {
        return this.modifyEmbed(this.$props.slice.primary.hero_video_embedded)
      } else {
        return null
      }
    },
  },
  methods: {
    clickawayVideoModal(e) {
      if (
        this.isVideoModalOpen &&
        e.target.id !== 'video-modal-close-icon' &&
        e.target.id !== 'video-modal-close' &&
        e.target.id !== 'live.demo.preview.button'
      ) {
        this.isVideoModalOpen = false
      }
    },
    toggleVideoModal(e) {
      this.isVideoModalOpen = !this.isVideoModalOpen
    },
    modifyEmbed(embed) {
      const widthRegExp = /width="[0-9]+"/
      const heightRegExp = /height="[0-9]+"/

      embed.html = embed.html
        .replace(widthRegExp, '')
        .replace(heightRegExp, '')
        .replace(
          'feature=oembed',
          'feature=oembed&rel=0&origin=https://www.athlyzer.com',
        )
        .replace('iframe', 'iframe class="aspect-video w-full mx-auto"')

      return embed
    },
  },
}
